<div class="form-container">
  <qform-form-header title="{{ 'NewFlow' | localize }}" [subtitle]="headerSubtitle"
    [isGuest]="isGuest" [timeZone]="guestTimeZone"></qform-form-header>

  @if (!startFlowInfo?.autoGenerateName ||
  !startFlowInfo?.autoGenerateDescription) {
  <div class="form-render-content">
    <p class="flow-information-label">{{ 'FlowInformation' | localize }}</p>
    @if(!startFlowInfo?.autoGenerateName) {
    <div class="padding">
      <label for="flowNameInput" class="m-0">{{ 'Name' | localize }}</label>
    </div>
    <input id="flowNameInput" type="text" class="form-control mb-3" required [formControl]="flowName" [ngClass]="
        flowName.invalid && (flowName.dirty || flowName.touched)
          ? 'border-danger'
          : ''
      " />
    } @if(!startFlowInfo?.autoGenerateDescription) {
    <div class="padding">
      <label for="flowDescriptionInput" class="m-0">{{
        'Description' | localize
        }}</label>
    </div>
    <input id="flowDescriptionInput" type="text" class="form-control mb-3" [(ngModel)]="flowDescription" />
    }
  </div>
  }

  <div class="form-render-content">
    <app-form-render-component [formComponents]="formComponents"></app-form-render-component>
  </div>

  @if(isGuest) {
  <div class="captcha-container">
    <re-captcha #captchaRef (resolved)="captchaResolved($event)"></re-captcha>
  </div>
  }

  <qform-buttons-container [buttonsList]="[
      { value: _localizationService.localize('Start'), key: '', disabled: isGuest && !captchaToken }
    ]" (optionSelected)="startFlow()"></qform-buttons-container>
</div>